// extracted by mini-css-extract-plugin
export default {"textarea":"AcceptChanges_textarea__0uNtU","content":"AcceptChanges_content__YTlb7"};